import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isStrongPassword, PASSWORD_REQUIREMENTS_MESSAGE } from '../../utils/passwordPolicy';
import toast from 'react-hot-toast';

const ResetPassword = () => {
    const { token } = useParams();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const { resetPassword } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isStrongPassword(newPassword)) {
            toast.error(PASSWORD_REQUIREMENTS_MESSAGE);
            return;
        }
        if (newPassword !== confirmPassword) {
            toast.error('Passwords do not match');
            return;
        }
        setLoading(true);
        const result = await resetPassword(token, newPassword);
        setLoading(false);
        if (result.success) {
            navigate('/login');
        }
    };

    return (
        <div className="login-container">
            <div className="login-box" style={{
                maxWidth: '750px',
                padding: '45px 55px',
                width: '100%'
            }}>
                <div className="srm-logo-big" style={{
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%'
                }}>
                    <img
                        src="/srm-logo.png"
                        alt="SRMIST Logo"
                        style={{
                            width: '180px',
                            height: 'auto',
                            margin: '0 auto 16px',
                            display: 'block',
                            backgroundColor: 'white',
                            padding: '18px',
                            borderRadius: '16px',
                            boxShadow: '0 6px 20px rgba(0,0,0,0.18)'
                        }}
                    />
                    <div style={{
                        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                        fontWeight: 600,
                        textAlign: 'center',
                        color: '#666',
                        fontSize: '14px',
                        borderTop: '1px solid #eee',
                        paddingTop: '15px',
                        width: '100%'
                    }}>
                        Set a New Password
                    </div>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>New Password</label>
                        <input
                            type="password"
                            className="form-control"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Enter new password"
                            required
                        />
                        <p style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>{PASSWORD_REQUIREMENTS_MESSAGE}</p>
                    </div>
                    <div className="form-group">
                        <label>Confirm New Password</label>
                        <input
                            type="password"
                            className="form-control"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Re-enter new password"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        style={{ width: '100%' }}
                        disabled={loading}
                    >
                        {loading ? 'Resetting...' : 'Reset Password'}
                    </button>
                    <button
                        type="button"
                        onClick={() => navigate('/login')}
                        className="btn"
                        style={{
                            width: '100%',
                            marginTop: '10px',
                            background: '#666',
                            color: 'white'
                        }}
                    >
                        Back to Login
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;
